<script>
import BetterCareIcon from './BetterCareIcon.vue'
import EasierBudgetingIcon from './EasierBudgetingIcon.vue'
import MoreAffordableIcon from './MoreAffordableIcon.vue'
import LongerLifeIcon from './LongerLifeIcon.vue'

export default {
  name: 'BenefitIcon',
  props: ['bgColor', 'icon'],
  components: {
    BetterCareIcon,
    EasierBudgetingIcon,
    MoreAffordableIcon,
    LongerLifeIcon,
  },
}
</script>

<template>
  <div class="container" :class="bgColor">

        <div class="svgwrapper">
          <component :is="icon || 'BetterCare'" />
        </div>
        <div class="diamond"></div>

  </div>
</template>
<style lang="scss" scoped>
.container {
  position: relative;

}
@media only screen and (max-width: 960px) {
  .container {
    // left: 33%;
    max-width: 125px;
  }
}

.svgwrapper {
  position: absolute;
  z-index: 2;
  top: 34px;
  left: 34px;
}

.diamond {
  z-index: 1;
  width: 0;
  height: 0;
  border: 50px solid transparent;
  position: relative;
  top: -50px;
}
.diamond:after {
  content: '';
  position: absolute;
  left: -50px;
  top: 50px;
  width: 0;
  height: 0;
  border: 50px solid transparent;
}
.ico-green .diamond {
  border-bottom-color: $hpp-green;
}
.ico-green .diamond:after {
  border-top-color: $hpp-green;
}
.ico-blue .diamond {
  border-bottom-color: #068198;
}
.ico-blue .diamond:after {
  border-top-color: #068198;
}
.ico-yellow .diamond {
  border-bottom-color: #F7971D;
}
.ico-yellow .diamond:after {
  border-top-color: #F7971D;
}
.ico-red .diamond {
  border-bottom-color: #EF5335;
}
.ico-red .diamond:after {
  border-top-color: #EF5335;
}
</style>
